import styled from '@emotion/styled';
import { Tab } from '@mui/material';

export const TabButton = styled(Tab)`
    color: ${({ theme }) => theme.colors.secondary[900]} !important;
    width: 50%;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    text-transform: none;

    :hover {
        color: ${({ theme }) => theme.colors.secondary[700]} !important;
    }
`;
